import {lazy} from 'react';
import {useAuthStore} from '@/store/auth_store';
import {useRosterStore} from '@/store/roster_store';
import Wrapper from '@common/pages/Wrapper';
import RemoteComponent from '@common/RemoteComponent';

const NetworkRegistry = lazy(() => import('thoth/NetworkRegistry'));

export default function NetworkRegistryPage() {
  const authStore = useAuthStore();
  const rosterStore = useRosterStore();

  return (
    <Wrapper>
      <RemoteComponent
        remote="thoth"
        component={NetworkRegistry}
        authStore={authStore}
        rosterStore={rosterStore}
      />
    </Wrapper>
  );
}
